import useResetForm from 'stimulus-hooks/use-reset-form';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['error'];

  connect() {
    useResetForm(this);
  }

  requestSubmit(event) {
    const form = event.target.closest('form');
    if (!(form instanceof HTMLFormElement)) return;
    form.requestSubmit();
  }

  showErrors(event) {
    const [, , xhr] = event.detail;
    const { errors } = JSON.parse(xhr.response);
    this.errorTargets.forEach(showRelatedErrors(errors));
  }

  resetForm() {
    this.errorTargets.forEach((target) => {
      target.innerText = '';
    });
  }
}

function showRelatedErrors(errors) {
  return (field) => {
    const dataName = field.getAttribute('data-name');
    const type = JSON.parse(dataName);
    const errorMsg = extractError({ errors, type });
    field.innerText = errorMsg || '';
  };
}

function extractError({ errors, type }) {
  if (!errors || !Array.isArray(errors)) return '';

  const foundError = errors.find((error) => {
    const errorType = error.type.toLowerCase();

    if (Array.isArray(type)) return type.map((t) => t.toLowerCase()).includes(errorType);
    return errorType === type.toLowerCase();
  });

  return foundError?.detail;
}
